import { ApiBuilder } from "@epcnetwork/core-ui-kit";

import { appEnvironment } from "config/environment.config";
import { REFRESH_TOKEN_STORAGE_FIELD, TOKEN_STORAGE_FIELD } from "constants/auth.constants";
import { postRefreshToken } from "./api.refresh-token";
import store, { setToken } from "store";

type ServerErrorTypes =
  | string
  | {
      errors: string[];
      statusCode: number;
    }
  | {
      msg: string;
      statusCode: number;
    };

export const apiMiddleware = new ApiBuilder<ServerErrorTypes>({ baseUrl: appEnvironment.apiUrl })
  .setErrorsMapper((error: ServerErrorTypes) => {
    if (typeof error === "string") {
      return error;
    }
    if ("errors" in error && error?.errors?.[0]) {
      return error.errors[0];
    }
    if ("msg" in error && error?.msg) {
      return error.msg;
    }
    return JSON.stringify(error);
  })
  .setInterceptors(async (res, instance) => {
    const [, , { status }] = res;
    const refreshToken = localStorage.getItem(REFRESH_TOKEN_STORAGE_FIELD);
    if (refreshToken && status === 401) {
      const [data] = await postRefreshToken.fetch({
        data: {
          refresh_token: refreshToken,
        },
      });

      if (data?.response?.token && data?.response?.refresh_token) {
        store.dispatch(setToken(data.response.token));
        localStorage.setItem(TOKEN_STORAGE_FIELD, data.response.token);
        localStorage.setItem(REFRESH_TOKEN_STORAGE_FIELD, data.response.refresh_token);
        return await instance.setIsRetry(true).fetch();
      }
    }
    return res;
  })
  .setTokenGetter(() => {
    const state = store.getState();
    const authToken = state.auth.token;
    return authToken;
  })
  .build();
